<div class="main-ho-executive-resume">
    <div>
        <p class="title-section">Resumen Ejecutivo</p>
    </div>
    <div class="loading-shade" *ngIf="isLoading">
        <mat-spinner *ngIf="isLoading"></mat-spinner>
    </div>

    <div class="status-cards-row" *ngIf="!isLoading">
        <div class="status-card" *ngFor="let card of statusCards">
            <p class="status-card-category">{{ card.category }}</p>
            <p class="status-card-value" [ngClass]="'state-' + card.state">{{ card.value }}</p>
            <p class="status-card-detail">{{ card.detail }}</p>
        </div>
    </div>

    <div class="blocks-area" *ngIf="!isLoading">
        <div class="block-card" *ngFor="let block of blocks">
            <div class="block-card-header">
                <span class="block-dot" [ngClass]="'dot-' + block.dotColor"></span>
                <span class="block-card-title">{{ block.title }}</span>
            </div>

            <div class="block-card-body" [class.block-card-body--empty]="!block.archBar && !block.table">
                <!-- Barra de arquitectura (solo bloque Arquitectura) -->
                <div class="arch-bar-wrap" *ngIf="block.archBar">
                    <div class="arch-bar">
                        <div
                            class="arch-seg"
                            *ngFor="let segment of block.archBar.segments"
                            [ngClass]="'arch-seg-' + segment.state"
                            [style.flex]="segment.flex"
                        >
                            {{ segment.label }}
                        </div>
                    </div>
                    <div class="arch-legend">
                        <div class="arch-legend-item" *ngFor="let item of block.archBar.legend">
                            <span class="legend-box" [ngClass]="'legend-box-' + item.state"></span>
                            {{ item.label }}
                        </div>
                    </div>
                </div>

                <!-- Tabla comparativa Plan vs Real -->
                <div class="table-wrap" *ngIf="block.table">
                    <table class="executive-resume-table">
                        <thead>
                            <tr>
                                <th *ngFor="let column of block.table.columns" [class.col-highlight]="column.highlight">
                                    {{ column.label }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of block.table.rows">
                                <td
                                    *ngFor="let column of block.table.columns; let i = index"
                                    [class.col-highlight]="column.highlight"
                                    [class.strong]="row[i].strong"
                                    [class.muted]="row[i].muted"
                                    [class.delta-pos]="row[i].delta === 'pos'"
                                    [class.delta-neg]="row[i].delta === 'neg'"
                                    [class.delta-zero]="row[i].delta === 'zero'"
                                >
                                    <span class="badge" *ngIf="row[i].badge as badge" [ngClass]="'badge-' + badge.state">
                                        {{ badge.label }}
                                    </span>
                                    <span class="pill" *ngIf="!row[i].badge && row[i].pill">{{ row[i].pill }}</span>
                                    <ng-container *ngIf="!row[i].badge && !row[i].pill">
                                        {{ row[i].text }}
                                        <span class="cell-subtext" *ngIf="row[i].subtext">{{ row[i].subtext }}</span>
                                    </ng-container>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="footer-note" *ngIf="block.table.footerNote">{{ block.table.footerNote }}</p>
                </div>

                <!-- Fallback defensivo: bloque sin contenido -->
                <p class="block-card-empty" *ngIf="!block.archBar && !block.table">
                    Contenido disponible próximamente.
                </p>
            </div>
        </div>
    </div>
</div>
